import { ConvertibleObjectType } from '@ms/yammer-graphql';

type GetId = (legacyId: string, mappedType: ConvertibleObjectType) => string;
export const getId: GetId = (legacyId, mappedType) => `${mappedType}:${legacyId}`;
